<div
  class="input-box"
  [ngClass]="{
    hasError: _formControl.invalid && _formControl.touched,
    ignoreDisabledStyling: ignoreDisabledStyling,
    hasHint: !!hint
  }"
  [matTooltip]="getErrorMessage(_formControl)"
  matTooltipPosition="right"
  [matTooltipDisabled]="_formControl.valid || !_formControl.touched"
>
  <mat-form-field>
    <mat-label
      >{{ placeholder }}
      <span *ngIf="required" class="required">*</span></mat-label
    >

    <input
      *ngIf="!hasMask && !matAutocomplete"
      matInput
      [type]="type"
      [formControl]="_formControl"
      [value]="_formControl.value"
      [attr.maxlength]="maxlength"
    />
    <input
      *ngIf="hasMask"
      matInput
      [type]="type"
      [formControl]="_formControl"
      [value]="_formControl.value"
      [mask]="mask!"
      [attr.maxlength]="maxlength"
    />
    <input
      *ngIf="matAutocomplete"
      matInput
      [type]="type"
      [formControl]="_formControl"
      [matAutocomplete]="matAutocomplete"
      [value]="_formControl.value"
      [attr.maxlength]="maxlength"
    />
    <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
  </mat-form-field>
</div>
